import {
  getGetTopVocabularyListsQueryKey,
  getGetUserVocabularyListsQueryKey,
  likeVocabularyList,
  unlikeVocabularyList,
  useDeleteVocabularyList,
  useGetTopVocabularyLists,
  useGetUserVocabularyLists,
} from "@packages/api/madlenAPI";
import GenericToolPage from "../../components/tool_components/GenericToolPage";
import SingleVocabulary from "../../components/vocabularies/SingleVocabulary";
import i18n from "@packages/i18n/config";

interface ExtendedTool {
  id: number;
  imageUrl?: string;
  prompt?: string;
  authorName?: string;
  likeCount?: number;
  courseName?: string;
  gradeLevel?: number;
  didUserLiked?: boolean;
  description?: string;
  vocabulary?: any[];
  title?: string;
  isEditable?: boolean;
  createdAt?: string;
  contentLanguage?: string;
}

const VocabularyDetailComponent = ({ tool }: { tool: ExtendedTool }) => {
  return (
    <SingleVocabulary
      id={tool.id}
      isEditable={tool.isEditable || false}
      vocabulary={tool.vocabulary || []}
      courseName={tool.courseName}
      gradeLevel={tool.gradeLevel}
      topic={tool.title || tool.prompt || ""}
      imageUrl={tool.imageUrl}
      author={tool.authorName}
      createdAt={tool.createdAt}
      contentLanguage={tool.contentLanguage || i18n.language}
    />
  );
};

const VocabulariesView = () => {
  return (
    <GenericToolPage
      useGetTools={useGetUserVocabularyLists}
      useDeleteTool={useDeleteVocabularyList}
      getGetToolsQueryKey={getGetUserVocabularyListsQueryKey}
      useGetTopTools={useGetTopVocabularyLists}
      likeTool={likeVocabularyList}
      unlikeTool={unlikeVocabularyList}
      getGetTopToolsQueryKey={getGetTopVocabularyListsQueryKey}
      toolType="vocabularies"
      toolPath="vocabularies"
      DetailComponent={VocabularyDetailComponent}
      colors={{
        light: "from-cyan-600 to-cyan-500",
        dark: "dark:from-cyan-400 dark:to-cyan-300",
        iconBg: "bg-cyan-100 dark:bg-cyan-900/50",
        iconColor: "text-[#00acc1] dark:text-[#26c6da]",
        hover: "hover:bg-cyan-50 dark:hover:bg-cyan-900/20",
      }}
      toolColor="cyan"
      gradientColor="rose"
    />
  );
};

export default VocabulariesView;
